import { useEffect, useState } from 'react';
import SchemaRepo from '../../../../utils/repository/schemaRepo';
import { SchemaType } from '../types';
import ImportsRepo from '../../../../utils/repository/importsRepo';

function useSchema(
    schemaId: number | undefined,
    importId: string | undefined,
    simulated: boolean
): [SchemaType | null, boolean] {
    const [data, setData] = useState<SchemaType | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (simulated) {
            if (importId) {
                setIsLoading(true);
                ImportsRepo.getSimulatedSchema(importId, (schema: any) => {
                    setData(schema.data);
                    setIsLoading(false);
                });
            }
        } else {
            if (schemaId) {
                setIsLoading(true);
                SchemaRepo.get(schemaId, (schema: SchemaType) => {
                    setData(schema);
                    setIsLoading(false);
                });
            }
        }
    }, [schemaId, importId, simulated]);

    return [data, isLoading];
}

export default useSchema;
